<div class="custom-appRoot-container">
  <app-nav class="layout-nav"></app-nav>
  <div class="layout-body">
    <router-outlet></router-outlet>
  </div>
  <app-footer class="layout-footer"></app-footer>
</div>
